import { render, staticRenderFns } from "./ApnReservaNaturalDefensa.vue?vue&type=template&id=471be31a&scoped=true&lang=pug"
import script from "./ApnReservaNaturalDefensa.vue?vue&type=script&lang=js"
export * from "./ApnReservaNaturalDefensa.vue?vue&type=script&lang=js"
import style0 from "./ApnReservaNaturalDefensa.vue?vue&type=style&index=0&id=471be31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471be31a",
  null
  
)

export default component.exports